import { getProductsByMarketIdAndContract, isLaterThanWeekAfterToday } from '../services/utils';
import { ContractTypes } from '../constants/contract';
import { IndicesFrequency } from '../constants/indices';

const CONTRACT_TYPES = [ContractTypes.CME, ContractTypes.OTC];

const formatMarketName = (name, indicesFrequency) => `${name} (${indicesFrequency})`;

const getMarketsList = state => {
    const markets = state.indices.marketsList;

    const marketsList = markets.reduce((agg, market) => {
        const { id, name, products = [] } = market;

        if (
            products.find(p => p.indices_frequency_type === IndicesFrequency.DAILY) &&
            products.find(p => p.indices_frequency_type === IndicesFrequency.WEEKLY)
        ) {
            return [
                ...agg,
                {
                    id,
                    marketId: `${id}_${IndicesFrequency.WEEKLY}`,
                    frequency_type: IndicesFrequency.WEEKLY,
                    name: formatMarketName(name, IndicesFrequency.WEEKLY),
                },
                {
                    id,
                    marketId: `${id}_${IndicesFrequency.DAILY}`,
                    frequency_type: IndicesFrequency.DAILY,
                    name: formatMarketName(name, IndicesFrequency.DAILY),
                },
            ];
        }

        const indicesFrequencyType = products[0] ? products[0].indices_frequency_type : IndicesFrequency.WEEKLY;

        return [
            ...agg,
            {
                id: market.id,
                marketId: `${id}_${indicesFrequencyType}`,
                name: market.name,
                frequency_type: indicesFrequencyType,
            },
        ];
    }, []);

    return marketsList;
};

const getIndicesPreviewProducts = state => {
    const { products } = state.user.userInfo;
    const marketId = state.indices.market_id;

    return getProductsByMarketIdAndContract(marketId, CONTRACT_TYPES, products);
};

const getMarketIndicesDates = state => {
    const { indicesShedule, frequencyType } = state.indices;
    const data = indicesShedule && indicesShedule[frequencyType];
    return data ? data.selectedDates.filter(d => !isLaterThanWeekAfterToday(d)) : [];
};

export { getMarketsList, getIndicesPreviewProducts, getMarketIndicesDates };



// WEBPACK FOOTER //
// ./source/selectors/indicesSelectors.js